export default function useEmotiiBounds(bipolar) {
  if (bipolar) {
    return {
      min: -1,
      max: 1,
    };
  } else
    return {
      min: 0,
      max: 1,
    };
}
